import { UnderwritingActivityPatchRequestBody, UnderwritingActivityPostResponse } from '@lio/api-types';
import { queryKeys } from '@services/underwritingReferral';
import { useQueryClient, useMutation } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

export const useUpdateUnderwritingActivity = () => {
  const client = useClient();
  const queryClient = useQueryClient();
  const mutationFn = (body: UnderwritingActivityPatchRequestBody & { id: string }) =>
    client
      .patch(`underwriting-activity/${body.id}`, {
        json: {
          description: body.description,
          note: body.note,
          resolutionReasonId: body.resolutionReasonId !== '' ? body.resolutionReasonId : undefined,
        },
      })
      .json<UnderwritingActivityPostResponse>();
  const result = useMutation({
    mutationFn,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [queryKeys.underwritingActivity] });
    },
  });
  return { ...result, updateUnderwritingActivity: result.mutateAsync };
};
